import { Inject, Injectable } from "@angular/core";
import { PonderTasksClientBase } from "./ponder-tasks-client-base";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable({ providedIn: "root" })
export class PonderTasksClient extends PonderTasksClientBase {
    public constructor(@Inject(HttpClient) httpClient: HttpClient) {
        super(httpClient, `${environment.ponderBaseUrl}/tasks`);
    }
}